import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import CheckBoxComponent from "./checkbox-filter-results-component";
import MultiRangeSlider from "./slider-multi-range-component";
import { HiXMark } from "react-icons/hi2";
import { currencies } from "src/core/statics/filter-results/checkbox-filter-results-data";
import { useTranslation } from "react-i18next";

interface IProps {
  openFilterMobile: boolean;
  closeFilterMobile: () => void;
}
function FilterResultsComponent(props: IProps) {
  const { i18n, t } = useTranslation();
  const min = 10000;
  const max = 90000;
  const [values, setValues] = useState([min, max]);
  const [openCurrencies, setOpenCurrencies] = useState(false);
  const [selectCurrency, setSelectCurrency] = useState("SAR");
  return (
    <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
      <div className="flex flex-col w-[370px] mt-[42px] mobile:hidden tablet:hidden">
        <p className="text-xl font-arBold text-zinc500 p-2.5">
          {t("app.shared.filtering")}
        </p>
        <div className="h-auto bg-white rounded-2xl shadow-[rgba(0,_0,_0,_0.05)0px_0px_20px_0px]">
          <div className="h-[186px] rounded-t-2xl">
            <div className="flex flex-row gap-3">
              <p className="text-xl font-arRegular text-zinc600 w-[179px] h-[44px] px-3 py-2.5">
                {t("app.shared.budget")}{" "}
              </p>
              <div className="flex flex-col w-[179px]">
                <div
                  dir="rtl"
                  className="flex flex-row items-center justify-center py-2.5 pr-8 gap-2 cursor-pointer"
                  onClick={() => setOpenCurrencies(!openCurrencies)}
                >
                  {openCurrencies ? (
                    <FiChevronUp className="text-zinc600" size={24} />
                  ) : (
                    <FiChevronDown className="text-zinc600" size={24} />
                  )}

                  <p className="font-arMedium text-zinc600 text-base">
                    {t("app.shared.currency")} :{" "}
                    {selectCurrency === "SAR"
                      ? t("filterResult.component.riyal")
                      : selectCurrency === "USD"
                      ? t("filterResult.component.dolar")
                      : ""}
                  </p>
                </div>
                {openCurrencies && (
                  <div className="flex flex-col w-[175px] shadow-[rgba(0,_0,_0,_0.10)0px_0px_20px_0px] rounded-lg mt-10 mr-[35px] absolute bg-zinc50 z-20">
                    {currencies.map((item, index) => (
                      <div
                        className={`pr-6 p-3 font-arMedium text-sm ${
                          selectCurrency === item.id
                            ? "text-mint-500"
                            : "text-blue600 cursor-pointer"
                        }`}
                        key={index}
                        onClick={() => {
                          setSelectCurrency(item.id);
                          setOpenCurrencies(!openCurrencies);
                        }}
                      >
                        {i18n.language === "ar"
                          ? item.currency
                          : item.currencyEn}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col px-3 py-2.5 gap-[13px]">
              <p
                dir="rtl"
                className="text-2xl text-blue600 font-arRegular py-3"
              >
                {values[1].toLocaleString("en-US")} -{" "}
                {values[0].toLocaleString("en-US")}
              </p>
              <MultiRangeSlider
                values={values}
                min={min}
                max={max}
                onChange={setValues}
              />
            </div>
          </div>
          <hr className="mx-3"></hr>
          <CheckBoxComponent />
        </div>
      </div>
      {/* mobile */}
      {props.openFilterMobile && (
        <div className="absolute top-16 right-0 left-0 flex flex-col justify-center items-center bg-white w-full py-3 gap-3 z-20 laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden">
          <div className="">
            <div className="flex flex-row justify-between">
              <HiXMark
                className="text-zinc400 cursor-pointer"
                size={24}
                onClick={props.closeFilterMobile}
              />
              <p className="text-zinc400 text-sm cursor-pointer">
                {t("filterResults.component.erase")}
              </p>
            </div>
            <div className="flex flex-col w-[370px] mt-[42px] items-start">
              <div className="h-auto bg-white rounded-2xl">
                <div className="h-[186px] rounded-t-2xl">
                  <div className="flex flex-row gap-3">
                    <p className="text-xl font-arRegular text-zinc600 w-[179px] h-[44px] px-3 py-2.5">
                      {t("app.shared.budget")}{" "}
                    </p>
                    <div className="flex flex-col w-[179px]">
                      <div
                        className="flex h-[44px] py-2.5 pr-8 gap-2 cursor-pointer"
                        onClick={() => setOpenCurrencies(!openCurrencies)}
                      >
                        {openCurrencies ? (
                          <FiChevronUp className="text-zinc600" size={24} />
                        ) : (
                          <FiChevronDown className="text-zinc600" size={24} />
                        )}

                        <p className="font-arMedium text-zinc600 text-base">
                          {t("app.shared.currency")} :{" "}
                          {selectCurrency === "SAR"
                            ? t("filterResult.component.riyal")
                            : selectCurrency === "USD"
                            ? t("filterResult.component.dolar")
                            : ""}
                        </p>
                      </div>
                      {openCurrencies && (
                        <div className="flex flex-col w-[175px] shadow-[rgba(0,_0,_0,_0.10)0px_0px_20px_0px] rounded-lg mt-10 mr-[35px] absolute bg-zinc50 z-20">
                          {currencies.map((item, index) => (
                            <div
                              className={`pr-6 p-3 font-arMedium text-sm ${
                                selectCurrency === item.id
                                  ? "text-mint-500"
                                  : "text-blue600 cursor-pointer"
                              }`}
                              key={index}
                              onClick={() => {
                                setSelectCurrency(item.id);
                                setOpenCurrencies(!openCurrencies);
                              }}
                            >
                              {item.currency}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col px-3 py-2.5 gap-[13px]">
                    <p className="text-2xl text-blue600 font-arRegular py-3">
                      {values[1].toLocaleString("en-US")} -{" "}
                      {values[0].toLocaleString("en-US")}
                    </p>
                    <MultiRangeSlider
                      values={values}
                      min={min}
                      max={max}
                      onChange={setValues}
                    />
                  </div>
                </div>
                <hr className="mx-3"></hr>
                <CheckBoxComponent />
              </div>
            </div>
          </div>
          <button className="flex justify-center items-center w-[166px] h-11 bg-mint-500 rounded-xl text-zinc-50 text-xl font-arMedium">
            {t("filterResults.component.showResults")}
          </button>
        </div>
      )}
    </div>
  );
}

export default FilterResultsComponent;
